export const ROUTE_PATH = '/reconciliations-cp';

export const FEATURE_NAME = 'reconciliationPage';

export const POST_URL = '/reconciliation/';

export const REPAY_CONFIRMATION_MSG =
  'Вы уверены, что хотите завершить данную реконсиляцию?';
